import { render } from "./Slot.vue?vue&type=template&id=bb0b53f6&scoped=true"
import script from "./Slot.vue?vue&type=script&lang=js"
export * from "./Slot.vue?vue&type=script&lang=js"

import "./Slot.vue?vue&type=style&index=0&id=bb0b53f6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bb0b53f6"

export default script